import {t} from "@lingui/macro";
import {Mode, Tier} from "~services/business/pricing";

export const tierModeOptions = [
    {
        value: Mode.MONTHLY,
        text: t`global.pricing.monthly`,
    },
    {
        value: Mode.YEARLY,
        text: t`global.pricing.yearly`,
    },
];

export const tierNameOptions = [
    {
        value: Tier.START,
        text: t`global.pricing.priceTable.start.heading`,
    },
    {
        value: Tier.PLUS,
        text: t`global.pricing.priceTable.plus.heading`,
    },
    {
        value: Tier.PREMIUM,
        text: t`global.pricing.priceTable.premium.heading`,
    },
    {
     value: Tier.TEST,
     text: t`global.pricing.priceTable.premium.heading`,
    },
]
  